import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ModuleService, Module, CategoryContent, SubSection } from "@core/navigation/module.service";
import { NavigationService } from "@core/navigation/navigation.service";
import { LayoutService } from "@lhacksrt/services/layout/layout.service";


@Component({
    selector: 'select-module-dialog',
    templateUrl: './select-module-dialog.component.html',
    standalone: false
})
export class SelectModuleDialogComponent implements OnInit {

    private readonly FALLBACK_ICON = 'assets/images/logo/logo.png';
    private failedIcons = new Set<string>();

    modulesByCategory: Map<string, CategoryContent> = new Map<string, CategoryContent>();
    categories: string[] = [];
    selectedCategoryIndex: number = 0;
    selectedSubCategoryIndex: number = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            modules: Module[];
        },
        public dialogRef: MatDialogRef<SelectModuleDialogComponent>,
        private _layoutService: LayoutService,
        private _navigationService: NavigationService,
        public _moduleService: ModuleService,
        private _router: Router
    ) {
    }

    ngOnInit(): void {
        this.modulesByCategory = this._moduleService.getModulesByCategory();
        this.categories = Array.from(this.modulesByCategory.keys());
        this.setInitialTabSelection();
    }

    private setInitialTabSelection(): void {
        const currentModule = this._moduleService.getCurrentModule();
        const targetCategory = currentModule?.category || "Automobile";

        this.selectedCategoryIndex = Math.max(0, this.categories.indexOf(targetCategory));

        if (currentModule?.subCategory) {
            const content = this.modulesByCategory.get(targetCategory);
            if (content && this._moduleService.isSubSection(content)) {
                const idx = (content as SubSection[]).findIndex(
                    s => s.title === currentModule.subCategory
                );
                this.selectedSubCategoryIndex = Math.max(0, idx);
            }
        }
    }

    get activeContent(): CategoryContent | undefined {
        return this.modulesByCategory.get(this.categories[this.selectedCategoryIndex]);
    }

    get isSubSection(): boolean {
        return !!this.activeContent && this._moduleService.isSubSection(this.activeContent);
    }

    get activeSubSections(): SubSection[] {
        return this.activeContent as SubSection[];
    }

    get activeModules(): Module[] {
        if (this.isSubSection) {
            return this.activeSubSections[this.selectedSubCategoryIndex]?.modules || [];
        }
        return this.activeContent as Module[] || [];
    }

    selectCategory(index: number): void {
        this.selectedCategoryIndex = index;
        this.selectedSubCategoryIndex = 0;
    }

    getModuleIcon(module: Module): string {
        if (!module.displayIcon || this.failedIcons.has(module.displayIcon)) {
            return this.FALLBACK_ICON;
        }
        return module.displayIcon;
    }

    onIconError(module: Module): void {
        if (module.displayIcon && module.displayIcon !== this.FALLBACK_ICON) {
            this.failedIcons.add(module.displayIcon);
        }
    }

    isFallbackIcon(module: Module): boolean {
        return this.getModuleIcon(module) === this.FALLBACK_ICON;
    }

    selectModule(item: Module) {
        if (item.enabled === false) {
            return;
        }
        localStorage.setItem("module", item.name);
        const nav = this._navigationService.getNavigation(item.name);
        this._navigationService.currentNavigation = nav;
        this._layoutService.setNavigation(nav);
        this._moduleService.module = item;
        this._router.navigate(["/dashboard"], { queryParams: { module: item.name } });
        this.dialogRef.close();
    }
}
